/* eslint-disable */
export default {
  noActiveCalls: 'Ei käynnissä olevia puheluita',
  noCalls: 'Hakutuloksia ei löytynyt.',
  currentCall: 'Nykyinen puhelu',
  ringCall: 'Soitettava puhelu',
  onHoldCall: 'Puhelu pidossa',
  historyCalls: 'Aiemmat puhelut',
  otherDeviceCall: 'Käynnissä olevat puhelut muilla laitteillani',
  searchPlaceholder: 'Haku...',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
